import { KibGrid } from '@chewy/kib-layout-react'

import { MessageVariant, MessageWay } from '~/constants/communications'
import type { ChatMessage } from '~/types'

import MessageCardV2 from './v2/MessageCardV2'

export interface ChatMessageV2Props {
  message: ChatMessage
  readOnly?: boolean
  variant?: MessageVariant
}

const ChatMessageV2 = ({
  message,
  readOnly = false,
  variant = MessageVariant.PRIMARY,
}: ChatMessageV2Props) => {
  const isOutbound = message?.way === MessageWay.OUTBOUND

  return (
    <KibGrid align={isOutbound ? 'right' : 'left'}>
      <MessageCardV2 message={message} readOnly={readOnly} variant={variant} />
    </KibGrid>
  )
}

export default ChatMessageV2
